// extracted by css-extract-rspack-plugin
export default {"page":"styles-module__page__nxawh","subnav":"styles-module__subnav__sFh0u"};